export const padZeros = (num: number, digits: number) => {
    const digitsInNum = num.toString().length;
    if (num < 0 || digitsInNum > digits) {
        return num.toString();
    }

    const leadingZeros = '0'.repeat(digits);
    return (leadingZeros + num).slice(-digits);
};
